import React from "react";
import "./landingbox.css";

export default class LandingBoxHow extends React.Component {
  render() {
    return (
      <div className="landingBox">
        <h2>How It Works.</h2>
        <p>
          Start searching for local businesses and write some reviews. The
          review system is a bit unique in that you rate a place on 3 criteria -
          Quantity, Quality, and Pricing.
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landingbox/landingboxhow.js